import axios from "axios";
import { MDBDataTable } from "mdbreact";
import { Line } from 'react-chartjs-2';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip as ChartTooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    ChartTooltip,
    Legend,
);

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../Loading";

const mySwal = withReactContent(Swal);

const DropnGoDashboardCard = ({ token }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState("Graph")
    const [dataByMonth, setDataByMonth] = useState([])
    const [dataByDay, setDataByDay] = useState([])

    useEffect(() => {
        setLoading(true)
        axios
            .get("/api/admin/report/dashboard/dropngo", { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                setDataByMonth(res.data.data.dataByMonth)
                setDataByDay(res.data.data.dataByDay)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error")
            });
    }, [])

    let monthLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let monthDatasets = [];
    let monthTableDatasets = [];

    for (let i = 0; i < monthLabels.length; i++) {
        let foundData = dataByMonth.find(data => data.month === monthLabels[i]);
        let thisMonthData = foundData ? foundData.total_transaction_amount : 0
        monthDatasets.push(thisMonthData)
        monthTableDatasets.push({
            month: monthLabels[i],
            total_transaction_amount: thisMonthData
        })
    }

    const monthData = {
        labels: monthLabels,
        datasets: [
            {
                label: "Sales",
                data: monthDatasets,
                fill: false,
                borderColor: 'rgb(54, 162, 235)',
                tension: 0.3
            }
        ]
    };

    const monthOptions = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: t("Total Drop N Go Sales by Month")
            }
        }
    };

    const dayData = {
        labels: dataByDay.map(data => new Date(data.day).getDate()),
        datasets: [
            {
                label: "Sales",
                data: dataByDay.map(data => data.total_transaction_amount),
                fill: false,
                borderColor: 'rgb(54, 162, 235)',
                tension: 0.3
            }
        ]
    }

    const dayOptions = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: t("Total Drop N Go Sales by Day")
            }
        }
    };

    let monthTableData = {
        columns: [
            {
                label: t("Month"),
                field: "month",
                sort: "asc"
            },
            {
                label: t("Sales"),
                field: "total_transaction_amount",
                sort: "asc"
            },
        ],
        rows: monthTableDatasets
    }

    let dayTableData = {
        columns: [
            {
                label: t("Day"),
                field: "day",
                sort: "asc"
            },
            {
                label: t("Sales"),
                field: "total_transaction_amount",
                sort: "asc"
            },
        ],
        rows: dataByDay.map(data => ({
            day: new Date(data.day).toLocaleDateString('en-GB'),
            total_transaction_amount: data.total_transaction_amount
        }))
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <h5 className="card-title">{t("Drop N Go Dashboard")}</h5>

                <button className="btn btn-primary" type="button" onClick={() => setMode(mode === "Graph" ? "Table" : "Graph")}>
                    {mode === "Table" ? t("Graph") : t("Table")}
                </button>
            </div>

            <div className="card-body">
                {
                    loading ? <Loading /> : mode === "Graph" ? <Line data={monthData} options={monthOptions} /> : <MDBDataTable data={monthTableData} noBottomColumns striped hover responsive bordered paging={false} searching={false} />
                }

                {
                    loading ? <Loading /> : mode === "Graph" ? <Line data={dayData} options={dayOptions} /> : <MDBDataTable data={dayTableData} noBottomColumns striped hover responsive bordered />
                }
            </div>
        </div>
    )
}

export default DropnGoDashboardCard;